import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import {
  RightPanelModule,
  RightPanelModuleSettings,
} from '@common-modules/right-panel/right-panel.module';
import { TranslateModule } from '@ngx-translate/core';
import { AccountCardLayoutComponent } from './account-card-layout/account-card-layout.component';
import { LanguageSelectorComponent } from './language-selector/language-selector.component';
import { MainLayoutComponent } from './main-layout/main-layout.component';

export class CommonMainLayoutModuleSettings {
  rightPanelSettings?: RightPanelModuleSettings;
}

@NgModule({
  declarations: [MainLayoutComponent, LanguageSelectorComponent, AccountCardLayoutComponent],
  exports: [MainLayoutComponent, LanguageSelectorComponent, AccountCardLayoutComponent],
  imports: [
    CommonModule,
    MatMenuModule,
    MatIconModule,
    MatCardModule,
    MatDividerModule,
    MatTooltipModule,
    TranslateModule,
    RouterModule,
    DragDropModule,
    RightPanelModule,
  ],
})
export class CommonMainLayoutModule {
  static forFeature(
    settings: CommonMainLayoutModuleSettings,
  ): ModuleWithProviders<CommonMainLayoutModule> {
    let providers = [];

    if (settings.rightPanelSettings) {
      const rightPanelModuleWithProviders = RightPanelModule.forFeature(
        settings.rightPanelSettings,
      );

      if (rightPanelModuleWithProviders) {
        providers = providers.concat(rightPanelModuleWithProviders.providers ?? []);
      }
    }
    return {
      ngModule: CommonMainLayoutModule,
      providers,
    };
  }
}
